// @flow
import React from 'react'
import {withPopupToggles, withDialogError, withToggles} from 'startlibs/lib/hocs'
import {Errors, Combobox, SimpleRadiobox, Form, withForm, TextInput, Field} from 'startlibs/lib/form'
import {ImageUpload} from '../../components/imageUpload'
import {Button, DraggableContainer, DraggableItem, Dialog} from 'startlibs/lib/components'
import {ice} from 'icepath'
import {Fill} from 'react-slot-fill'
import styled, {css} from 'styled-components'
import {ManageSignaturesDialog} from './signatures/ManageSignaturesDialog'
import {createSelector} from 'reselect'
import {ReportSignatureView} from '../viewer/ReportSignatureView'

const SignaturesDialog = styled(Dialog)`
  max-width: 50rem;
`

@withToggles('createDialog')
export class Signatures extends React.Component {
  state = {}

  remove = (signature) => {
    const index = this.props.reportSignatures.findIndex(id => id === signature.id)
    this.setState({deletedSignature: {index, signature}})
    setTimeout(() => {
      if (this.state.deletedSignature) {
        this.props.confirmRemoveItem(signature.id)
        this.setState({deletedSignature: null})
      }
    }, 10000)
    this.props.remove(signature.id)
  }

  undoDelete = () => {
    const {signature, index} = this.state.deletedSignature
    this.props.addNew(signature, index)
    this.setState({deletedSignature: null})
  }

  save = (responsible) => this.props.addNew(responsible)

  setItemOrder = (from, to) => {
    const oldOrder = this.props.reportSignatures.map(_ => _.id)
    const newOrder = ice(oldOrder).splice(from, 1).splice(to, 0, oldOrder[from]).value()
    this.props.updateOrder(newOrder)
  }

  render() {
    const {newSignatureAction, hidePermissionsSettings, isEmbedded, uploadFetcher, reportSignatures, newId, getResource, update, createDialog, availableSignatures, availableSignaturesArray} = this.props
    const {deletedSignature} = this.state
    return (
      <div className="report-signatures">
        <DraggableContainer
          setDragRef={this.props.setDragRef}
          className="drag-drop-limits"
          setItemOrder={this.setItemOrder}
        >
          {reportSignatures.filter(_ => availableSignatures[_.signatureId]).map((signature, i) =>
            <ReportSignature
              index={i}
              hidePermissionsSettings={hidePermissionsSettings}
              getResource={getResource}
              key={signature.id}
              newSignatureAction={newSignatureAction}
              uploadFetcher={uploadFetcher}
              responsible={signature}
              availableSignatures={availableSignatures}
              availableSignaturesArray={availableSignaturesArray}
              update={update}
              isEmbedded={isEmbedded}
              remove={this.remove}
            />).concat([<a key="add-signature" className="new-signature-button" onClick={createDialog.open}><span
            className="icon icon-plus-circle"/>Add responsible signature</a>])
          }
        </DraggableContainer>

        {
          createDialog.isOpen &&
          <EditReportSignatureDialog
            save={this.save}
            getResource={getResource}
            isEmbedded={isEmbedded}
            hidePermissionsSettings={hidePermissionsSettings}
            formProperties={{id: newId, structure: 'digitally-signed', isCustom: true}}
            newSignatureAction={newSignatureAction}
            uploadFetcher={uploadFetcher}
            availableSignatures={availableSignatures}
            availableSignaturesArray={availableSignaturesArray}
            closeDialog={createDialog.close}/>
        }
        {deletedSignature && <Fill name="Notifications">
          <div className="system-notification undo-notification">Signature successfully deleted <a
            className="button small-button" onClick={this.undoDelete}>Undo</a></div>
        </Fill>}
      </div>
    )
  }
}

@withPopupToggles('contextMenu')
@withToggles('editDialog')
class ReportSignature extends React.Component {

  remove = () => this.props.remove(this.props.responsible)

  render() {
    const {responsible, isEmbedded, hidePermissionsSettings, newSignatureAction, uploadFetcher, getResource, contextMenu, index, editDialog, availableSignatures, availableSignaturesArray, update} = this.props
    const signature = availableSignatures[responsible.signatureId]
    return (
      <DraggableItem
        id={responsible.id}
        index={index}
        className={'signature-container ' + responsible.structure}
        onClick={editDialog.open}
        ghostScale={1.02}
      >
        <a data-drag={false} className="button small-button edit-button dropdown" onClick={contextMenu.toggle}>Edit</a>
        {
          contextMenu.isOpen &&
          <ul data-drag={false} className="context-menu">
            <li onClick={editDialog.open}><a>Change signature</a></li>
            <li onClick={this.remove}><a>Remove</a></li>
          </ul>
        }
        <ReportSignatureView getResource={getResource} signature={signature} responsible={responsible}/>

        {
          editDialog.isOpen &&
          <EditReportSignatureDialog
            editing
            getResource={getResource}
            hidePermissionsSettings={hidePermissionsSettings}
            save={update}
            isEmbedded={isEmbedded}
            newSignatureAction={newSignatureAction}
            uploadFetcher={uploadFetcher}
            formProperties={responsible}
            availableSignaturesArray={availableSignaturesArray}
            availableSignatures={availableSignatures}
            closeDialog={editDialog.close}
          />
        }
      </DraggableItem>
    )
  }
}

const EMPTY_SIGNATURE = {name: '', description: '', permission: 'private'}

@withDialogError
@withForm()
@withToggles('createSignatureDialog', 'manageSignaturesDialog')
class EditReportSignatureDialog extends React.Component {

  getLabel = (responsible) => this.props.availableSignatures[responsible].name

  setOption = (option) => {
    const noDigital = (!option.digitalSignature && this.props.form.properties.structure === 'digitally-signed')
    this.props.form.connector.setValues(chain =>
      chain
        .update('structure', (s) => noDigital ? 'signed-after-printing' : s)
        .set('signatureId', option.signatureId)
    )
  }

  preValidation = (props) => {
    if (!props.signatureId) {
      return {errors: {'responsible': ['Please select a responsible signature.']}}
    } else {
      return {success: props}
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.availableSignaturesArray > this.props.availableSignaturesArray) {
      const newSignature = newProps.availableSignaturesArray.find(({signatureId}) => this.props.availableSignatures[signatureId] === undefined)
      this.setOption(newSignature)
    }
    if (newProps.form.properties.signatureId !== this.props.form.properties.signatureId) {
      this.setOption(newProps.availableSignatures[newProps.form.properties.signatureId])
    }
    if (this.props.createSignatureDialog.isOpen && !newProps.createSignatureDialog.isOpen && !newProps.availableSignaturesArray.length) {
      this.props.closeDialog()
    }
  }

  componentDidMount() {
    if (!this.props.availableSignatures.order.length) {
      this.props.createSignatureDialog.open()
    }
  }

  withoutDisabledsignatures = createSelector(
    (array) => array,
    array => array.filter(_=>!_.disabled).map(_=>_.signatureId)
  )

  render() {
    const {editing, closeDialog, availableSignaturesArray, manageSignaturesDialog, isEmbedded, getResource, children, newSignatureAction, uploadFetcher, availableSignatures, createSignatureDialog, form, hidePermissionsSettings} = this.props
    const signature = availableSignatures[form.properties.signatureId] || {digitalSignature: true}
    return (
      <SignaturesDialog
        title={editing ? 'Change responsible signature' : 'Add responsible signature'}
        className="report-signature-dialog"
        form={form}
        closeDialog={closeDialog}
      >
        <Dialog.Content>
          <Combobox
            label="Responsible name"
            form={form}
            path="signatureId"
            placeholder="Select who will sign the report"
            options={this.withoutDisabledsignatures(availableSignaturesArray)}
            getLabel={this.getLabel}
            tabIndex={1}
          />
        <Field label="Signature type">
          <div className="radio-list horizontal">
            <SimpleRadiobox
              form={form}
              path="structure"
              disabled={!signature.digitalSignature}
              fieldValue="digitally-signed"
              label="Digitally signed"
            />
            <SimpleRadiobox
              form={form}
              path="structure"
              fieldValue="signed-after-printing"
              label="Signed after printing"
            />
            <SimpleRadiobox
              form={form}
              path="structure"
              fieldValue="name-only"
              label="Name only (without signature)"
            />
          </div>
        </Field>
          <Errors form={form}/>
        </Dialog.Content>
        <Dialog.Footer>
          <Dialog.FooterAuxiliaryContainer>
            <Button onClick={manageSignaturesDialog.open}>Manage signatures</Button>
            {
              manageSignaturesDialog.isOpen &&
              <ManageSignaturesDialog
                signatures={availableSignatures}
                enabledSignatures={this.withoutDisabledsignatures(availableSignaturesArray)}
                closeDialog={manageSignaturesDialog.close}
                openCreateSignature={()=> manageSignaturesDialog.close() || createSignatureDialog.open()}
              />
            }
            {createSignatureDialog.isOpen &&
            <CreateNewSignatureDialog
              hidePermissionsSettings={hidePermissionsSettings}
              uploadFetcher={uploadFetcher}
              getResource={getResource}
              action={newSignatureAction}
              isEmbedded={isEmbedded}
              formProperties={EMPTY_SIGNATURE}
              onSuccess={createSignatureDialog.close}
              closeDialog={()=> createSignatureDialog.close() || manageSignaturesDialog.open()}
            />}
          </Dialog.FooterAuxiliaryContainer>
          <div>
            <Form form={form} handleSubmit={this.props.save} onSuccess={closeDialog} preValidation={this.preValidation}>
              <Button onClick={closeDialog}>Cancel</Button>
              <Button highlight isLoading={form.isLoading} type="submit">Save</Button>
            </Form>
          </div>
        </Dialog.Footer>
        {children}
      </SignaturesDialog>
    )
  }
}

@withDialogError
@withForm()
class CreateNewSignatureDialog extends React.Component {

  preValidation = (properties) => {
    if (!properties.name.trim()) {
      return {errors: {'name': ['Display name is required.']}}
    } else {
      return {success: properties}
    }
  }

  render() {
    const {closeDialog, onSuccess, form, children, getResource, uploadFetcher, hidePermissionsSettings, isEmbedded} = this.props
    return (
      <SignaturesDialog
        title="Create new signature"
        closeDialog={closeDialog}
        form={form}
        className='create-signature-dialog'>
        <Dialog.Content>
          <TextInput
            form={form}
            maxLength={255}
            autoFocus
            path="name"
            label='Display name'
          />
          <TextInput
            form={form}
            textarea
            maxLength={255}
            path="description"
            label='Description'
          />
          <Field
            label="Digital signature"
            descText="Import a digital signature to automatically assign your reports. Formats: PNG or JPG."
          >
            <ImageUpload
              uploadFetcher={uploadFetcher}
              form={form}
              getResource={getResource}
              path="digitalSignature"
              label="image"
              boxText="Click or drag and drop your image file here to upload it"
            />
          </Field>
          {
            !hidePermissionsSettings &&
            <React.Fragment>
              <Field label="Permission to use this digital signature">
              <div className="radio-list horizontal">
                <SimpleRadiobox
                  form={form}
                  path="permission"
                  fieldValue="private"
                  label="Only you"
                />
                <SimpleRadiobox
                  form={form}
                  path="permission"
                  fieldValue="organization"
                  label="Anyone in this organization"
                />
              </div>
            </Field>
            </React.Fragment>
          }
          <Errors form={form}/>
        </Dialog.Content>
        <Dialog.Footer>
          <Form form={form} preValidation={this.preValidation} onSuccess={onSuccess}>
            <Button onClick={closeDialog}>Cancel</Button>
            <Button highlight isLoading={form.isLoading} type="submit">Save</Button>
          </Form>
        </Dialog.Footer>
        {children}
      </SignaturesDialog>
    )
  }
}



// WEBPACK FOOTER //
// ./~/report-components/src/modules/editor/Signatures.js